/**
 * Cleva NA — Custom JS
 * All project-specific scripts live here.
 * Imported at end of <body> in theme.liquid.
 */

// Envision - Update wholescale reviews widget when collection pagination loads a new page
// Note: event is dispatched in collection-pagination-number.js
(function() {
  document.addEventListener('product-grid-refresh', (e) => {
    if (typeof window['fetchCollectionProductStars'] === 'function') {
      window.fetchCollectionProductStars();
    }
  });
})();

// Envision - Accessible navigation for footnote indicator links and the back-to-content link: scroll with sticky-header offset and move focus to the destination
(function() {
  function getHeaderOffset() {
    var value = getComputedStyle(document.body).getPropertyValue('--header-height');
    return parseFloat(value) || 0;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function navigateTo(target) {
    if (!target) return;

    function scrollToCurrentPosition() {
      var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
      window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    scrollToCurrentPosition();

    // Move focus to the destination so keyboard/screen-reader users land there too —
    // preventScroll avoids fighting our own offset-aware scroll above. Works on
    // #footnotes (given tabindex="-1" in footnotes.liquid) and on indicator <a>
    // elements (natively focusable already). Deliberately doesn't touch the URL/
    // history — that's not an accessibility requirement, and would otherwise force
    // readers to click "back" once per footnote visited just to leave the page.
    target.focus({ preventScroll: true });

    // Re-correct if the page layout shifts mid-scroll — e.g. a lazy-loading
    // embed further down the page (like the powr media gallery) animating
    // its height in as it scrolls into view, pushing the target further down
    if (typeof ResizeObserver === 'undefined') return;
    var settleTimeout;
    var observer = new ResizeObserver(function() {
      scrollToCurrentPosition();
      clearTimeout(settleTimeout);
      settleTimeout = setTimeout(function() {
        observer.disconnect();
      }, 500);
    });
    observer.observe(document.body);
    setTimeout(function() {
      clearTimeout(settleTimeout);
      observer.disconnect();
    }, 3000);
  }

  document.addEventListener('click', (e) => {
    const indicatorLink = e.target.closest('a[href="#footnotes"]');
    if (indicatorLink) {
      e.preventDefault();
      const backLink = document.getElementById('footnotes-back-link');
      if (backLink) {
        if (!indicatorLink.id) {
          indicatorLink.id = 'footnote-ref-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
        }
        backLink.setAttribute('href', '#' + indicatorLink.id);
      }
      navigateTo(document.getElementById('footnotes'));
      return;
    }

    const backLinkClicked = e.target.closest('#footnotes-back-link');
    if (backLinkClicked) {
      e.preventDefault();
      const targetId = backLinkClicked.getAttribute('href').slice(1);
      navigateTo(document.getElementById(targetId));
    }
  });
})();